<div class="jinni-carousel row bgc-white">
  <div class="px-sm-only-0 container xl-12 md-12 sm-12 xs-12">
    <div class="carousel-container" [ngClass]="{'done': done}">
      <div class="d-flex justify-content-between align-items-center mt-0 mt-sm-5 pt-4">
        <h1 class="color-prussian-blue px-3">{{ 'carousel.sectionTitle' | translate }}</h1>
        <span>
          <a [routerLink]="['/' + showLang, 'lotteries']" class="tt-capitalize font-proximanova color-cornflower-blue fz-14px me-3">{{ 'carousel.seeMoreLotteries' | translate }}</a>
          <img class="me-3 position-relative t2px h11px" src="../../assets/icons/double_arrow.png" alt="">
        </span>
      </div>
      <owl-carousel *ngIf="itemsSize"
                    [options]="{dotsEach: true, nav: false, checkVisible: true, lazyLoad: true, stageElement: disable, autoWidth: false, responsiveClass: true, responsive:{
                            '0':{ items:2 },
                            '1200':{ items:3 }
                            }}"
                    [items]="itemsArr"
                    [carouselClasses]="['owl-carousel','owl-theme','owl-drag', 'row']">
        <div class="item" *ngFor='let in of counter(itemsSize) ;let i = index'>
          <div class="slide pb-3 pb-sm-0 lottery-{{ valueOfIndex(i,'urlLotteryName') }}">
            <div class="lottery-top">
              <div class="fz-14px fz-sm-18px ms-0 ms-sm-5 name ps-5">{{ valueOfIndex(i, 'LotteryName') }}</div>
              <div class="award fz-15px fz-sm-18px ms-0 ms-sm-5 ps-5">
                <span *ngIf="itemsArr[i]['Jackpot'] == 0">{{ 'static.jackpotPending' | translate }}</span>
                <span
                  *ngIf="currency
                      && currency.Code
                      && itemsArr[i]['Jackpot'] > 0
                      && itemsArr[i]['Rates']['MoreRoundedJackpot'][itemsArr[i]['LotteryOriginCurrencyCode']]
                      && jackpotConfig.downloadedData"
                >
                  {{itemsArr[i]['Rates']['MoreRoundedJackpot'][itemsArr[i]['LotteryOriginCurrencyCode']] | currency: itemsArr[i]['LotteryOriginCurrencyCode']:itemsArr[i]['LotteryOriginCurrencySymbol']:'0.0':(subscriptionsService.countryCodeValue || 'en') | jackpot: (subscriptionsService.countryCodeValue || 'en'):itemsArr[i]['LotteryOriginCurrencySymbol']:showLang:false}}
                </span>
              </div>
            </div>
            <div class="logo-bg d-none"></div>
            <div class="lottery-bg box-shadow-basic"></div>
            <div class="logo-icon"></div>
            <div class="lottery-bottom">
              <div class="time"></div>
              <div class="przycisk bgc-malachite medium btn-playnow w-inherit">
                <a class="tt-capitalize fw-400"
                  [routerLink]="['/' + showLang, 'lotteries', valueOfIndex(i,'urlLotteryName')]">{{ 'carousel.betNow' | translate }}</a>
              </div>
              <app-universalcounter
                [lottery]="valueOfIndex(i,'LotteryID')">{{ 'carousel.loading' | translate }}</app-universalcounter>
            </div>
          </div>
        </div>
      </owl-carousel>
    </div>
  </div>
</div>

